import React, {useEffect, useState} from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import careersActions from "../../store/actions/careers";
import configActions from "../../store/actions/config";
import {useDispatch, useSelector} from "react-redux";
import InputMask from "react-input-mask";
import axios from "axios";
import careersStore from "../../store/reducer/careers";

const recaptchaRef = React.createRef();


const ModalApplyNow = () => {
    const configStore = useSelector((store) => store.configStore);
    const careersStore = useSelector((store) => store.careersStore);
    const dispatch = useDispatch();

    const [formError, setFormError] = useState(null);
    const [currentTopic, setCurrentTopic] = useState('');
    const [recaptchaValue, setRecaptchaValue] = useState('');
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    const setPhoneValue = (value) => {
        dispatch(configActions.setFormPhone(value));
        dispatch(configActions.setFormPhoneError(''));
    }
    const setEmailValue = (value) => {
        dispatch(configActions.setFormEmail(value));
        dispatch(configActions.setFormEmailError(''));
    }
    const setNameValue = (value) => {
        dispatch(configActions.setFormName(value));
        dispatch(configActions.setFormNameError(''));
    }
    const setCaptcha = () => {
        setRecaptchaValue(recaptchaRef.current.getValue());
    }

    const modalCLose = () => {
        let value = ''
        dispatch(configActions.setFormPhone(value));
        dispatch(configActions.setFormPhoneError(''));
        dispatch(configActions.setFormEmail(value));
        dispatch(configActions.setFormEmailError(''));
        dispatch(configActions.setFormName(value));
        dispatch(configActions.setFormNameError(''));
        dispatch(careersActions.setModalOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    const formSubmit = (event) => {
        event.preventDefault();
        dispatch(configActions.setFormEmailError(''));
        dispatch(configActions.setFormPhoneError(''));
        dispatch(configActions.setFormNameError(''));

        let formValid = true;
        let formErrorList = [];
        setFormError('');

        if (!configStore.formEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            formValid = false;
            formErrorList.push('form-email');
            dispatch(configActions.setFormEmailError('Enter correct email'));
        }
        if (configStore.formPhone.toString().slice(-1) === '_'){
            formValid = false;
            formErrorList.push('form-phone');
            dispatch(configActions.setFormPhoneError('Enter correct phone'));
        }

        if (configStore.formName.length < 3) {
            formValid = false;
            formErrorList.push('form-name');
            dispatch(configActions.setFormNameError('Enter your name'));
        }
        
        if (formValid) {
            sendForm();
        } else {
            document.getElementById(formErrorList[0]).scrollIntoView({block: "center", behavior: "smooth"});
        }
    }

    useEffect(() => {
        const NAME_FROM_BACK = "contact_form_apply_job_topic";
        
        axios.get(`${process.env.REACT_APP_API_BASE_URI}settings`)
            .then((response) => {
                const topics = response.data['hydra:member'];
                const currentTopic = topics.find((topic) => topic.name === NAME_FROM_BACK);

                setCurrentTopic(currentTopic);
            });
    }, []);

    const sendForm = () => {
        dispatch(configActions.setLoading(true))
        const today = new Date().toJSON();
        const data = {
            "topic": "api/email_topics/"+currentTopic.value,
            "subject": careersStore.formJobPosition,
            "content": careersStore.formJobPosition,
            "sentFrom": "Careers Page",
            "contactPreference": 0,
            "name": configStore.formName,
            "phone": configStore.formPhone,
            "email": configStore.formEmail,
            "createdAt": today,
            "updatedAt": today,
        };

        axios.post(`${process.env.REACT_APP_API_BASE_URI}email_histories`, data, { headers })
            .then(response => formResult(response)).catch(err => formError(err));

        const formResult = (response) => {
            dispatch(configActions.setFormPhone(''));
            dispatch(configActions.setFormEmail(''));
            dispatch(configActions.setFormName(''));
            window.grecaptcha.reset();
            dispatch(configActions.setModalSuccessOpen(true));
            dispatch(careersActions.setModalOpen(false));
            document.getElementsByTagName('body')[0].classList.add('modal-open');
            dispatch(configActions.setLoading(false))
        }

        const formError = (err) => {
            console.log(err)
            setFormError('An error occurred, please try again later')
            dispatch(configActions.setLoading(false))
        }
    }

    return (
        <div className="modal" id="apply-job-modal">
            <div className="modal-overlay"/>
            <div className="modal-block">
                <button
                    type='button'
                    className='modal-close'
                    onClick={() => {modalCLose()}}
                >
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} alt="close"/>
                </button>
                <div className="modal-heading-bg">
                    <div className="modal-title">Apply Now</div>
                    <div className="modal-subtitle">Thank you for your interest in applying for the open position.
                        Please complete the following information and we will email an application to you.</div>
                </div>
                <div className="modal-content ">
                    <form onSubmit={(ev) => {formSubmit(ev)}} className="form">
                        <div className={`form-loader ${configStore.isLoading ? 'is-loading' : ''}`}/>
                        <div className={`form-group ${configStore.formNameError.length > 0 ? 'error' : ''}`} id="form-name">
                            <div className="label">First and last name</div>
                            <input
                                placeholder='e.g. Jane Doe'
                                className='form-input'
                                onChange={(ev) => setNameValue(ev.target.value)}
                                onBlur={(ev) => setNameValue(ev.target.value.trim())}
                                value={configStore.formName}
                            />
                            {configStore.formNameError.length > 0 &&
                            <div className="input-error">{configStore.formNameError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formEmailError.length > 0 ? 'error' : ''}`} id="form-email">
                            <div className="label">Email address</div>
                            <input
                                placeholder='e.g. mail@company.com'
                                className='form-input'
                                onChange={(ev) => setEmailValue(ev.target.value)}
                                value={configStore.formEmail}
                            />
                            {configStore.formEmailError.length > 0 &&
                            <div className="input-error">{configStore.formEmailError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formPhoneError.length > 0 ? 'error' : ''}`} id="form-phone">
                            <div className="label">Your phone number (optional)</div>
                            <InputMask
                                mask="(999) 999-9999"
                                className='form-input'
                                placeholder='(555) 555-5555'
                                onChange={(ev) => setPhoneValue(ev.target.value)}
                                value={configStore.formPhone}
                            />
                            {configStore.formPhoneError.length > 0 &&
                            <div className="input-error">{configStore.formPhoneError}</div>
                            }
                        </div>
                        <div className="form-captcha">
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size="normal"
                                sitekey="6Ldn930UAAAAACn_tkcxOq1t7Ku9j24GuSrgwbTL"
                                onChange={() => {setCaptcha()}}
                            />
                        </div>
                        <button type='submit' className={`form-submit button-gradient ${recaptchaValue.length < 1 ? 'disabled' : ''}`} >Send</button>
                        <div className="form-error">{formError}</div>
                    </form>
                </div>
            </div>
        </div>
    );
}


export default ModalApplyNow;
